import { timezones } from 'data'

export const browserTimezone = () => {
    const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    return timezones.find(tz => tz.value === browserTimezone) ? browserTimezone : 'America/Los_Angeles'
}
